(function (root, factory) {
    if (typeof module === 'object' && typeof module.exports === 'object') {
        // CommonJS
        module.exports = factory(this);
    } else {
        //  全局变量
        factory(root);
    }
})(this, function (root) {
    var textUI = klass(
        function (json, editor) {
            if (!json) return;
            this.isdrag = false;
            this.selected = false;
            this.editSize = {};
            this.editor = editor;
            this.json = json;
            this.id = uuid.generate();
            this.lineHeight = 1;
            this.letterSpacing = 0;
            this.isdrag = false;
            this.dragX = 0;
            this.dragY = 0;
            var _this = this;
            var stopPop = function (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            var dashedstr = 'sprite-help-content sprite-help-content-dashed ';
            this.ele = $('<div ></div>').css({
                position: 'absolute',
                transformOrigin: '0px 0px 0px',
                border: '1px'
            }).mousedown(function (e) {
                //console.log(e)
            });

            this.ele[0].addEventListener('mousedown', function (e) {
                //console.log('mousedown',e);
            })

            window.addEventListener("mouseup", function (e) {
                _this.isdrag = false;
            })
            window.addEventListener("mousemove", function (e) {
                if (_this.isdrag) {
                    var dx = e.clientX - _this.dragX;
                    var dy = e.clientY - _this.dragY;
                    _this.dragX = e.clientX;
                    _this.dragY = e.clientY;
                    _this.editSize.left += dx;
                    _this.editSize.top += dy;
                    _this.json.outward.x = _this.editSize.left / _this.editor.scale;
                    _this.json.outward.y = _this.editSize.top / _this.editor.scale;
                    _this.ele.css({
                        left: _this.editSize.left + "px",
                        top: _this.editSize.top + "px",
                    });
                }
            })
            //console.log('ondrag', this.ele);

            this.textBox = $('<div autofocus></div>').css(this.json.font)
                .css({
                    'fontFamily': '"' + this.json.font.fontFamilyUrl.split('/').pop() + '"',
                    'white-space': 'pre-wrap',
                    'lineHeight': this.lineHeight,
                    'letterSpacing': this.letterSpacing * (~~(parseInt(this.json.font.fontSize) / 10)) + 'px',
                    '-webkit-background-clip': 'text',
                    height: 'auto',
                    width: this.json.width + 'px',
                    transformOrigin: '0px 0px 0px',
                    'writing-mode': 'inherit',
                });
            this.textBox.html(this.json.text);
            this.ele.empty().append(this.textBox);
            this.handler = $('<div></div>').css({
                left: 0,
                top: 0,
                width: this.editSize.width + 'px',
                height: this.editSize.height + 'px',
                position: 'absolute',
                transformOrigin: '0px 0px 0px',
            }).mousedown(function (e) {
                // console.log('this.handler', e, _this.editor.editable)
                // stopPop(e);
                // _this.selected = _this.editor.editable ? true : false;
                // if (_this.selected) {
                //     _this.isdrag = true;
                //     _this.dragX = e.clientX;
                //     _this.dragY = e.clientY;
                // }
                // eve('subtitle_selected_change', null, _this);
            }).click(e => {
                // stopPop(e);
            }).dblclick((e) => {
                // stopPop(e);
                // eve('subtitle_input_text', null, _this);
            }).mouseenter(function () {
                _this.handler.attr({
                    class: dashedstr + (_this.editor.editable ? 'active' : '')
                });
            }).mouseleave(function () {
                _this.handler.attr({
                    class: dashedstr + (_this.selected ? 'active' : '')
                });
            });
            this.handler[0].addEventListener('mousedown', function (e) {
                stopPop(e);
                _this.selected = _this.editor.editable ? true : false;
                if (_this.selected) {
                    _this.isdrag = true;
                    _this.dragX = e.clientX;
                    _this.dragY = e.clientY;
                }
                eve('subtitle_selected_change', null, _this);
            });
            this.handler[0].addEventListener("click", function (e) {
                stopPop(e);
            });
            this.handler[0].addEventListener("dblclick", function (e) {
                stopPop(e);
                eve('subtitle_input_text', null, _this);
            });



            this.ele.append(this.handler);

            this.updateUI();
        })
        .statics({
            MIN_FONTSIZE: 6,
            MAX_FONTSIZE: 500,
            defaultStyle: {
                "color": "#303233",
                "fontSize": 50,
                "fontFamilyUrl": "2018-5-16/1526467728442.TTF",
                "fontStretch": "normal",
                "fontWeight": "normal",
                "fontStyle": "normal",
                "textDecoration": "none",
                "textAlign": "center",
                "wordBreak": "break-word",
                "writingMode": "inherit"
            },
            defaultShadow: {
                "x": 0,
                "y": 0,
                "blur": 0,
                "spread": 0,
                "color": "#303233"
            },
            New: function (pos, editor) {
                var json = {
                    "startTime": pos.startTime,
                    "endTime": pos.endTime,
                    "text": "添加字幕",
                    "outward": {
                        "opacity": 1.0,
                        "rotation": 0.0,
                        "width": editor.json.resolution.width * 0.8,
                        "height": 50,
                        "x": editor.json.resolution.width * 0.1,
                        "y": editor.json.resolution.height - textUI.defaultStyle.fontSize * 2,
                        "isFlipped": false
                    },
                    "dropShadow": Object.assign({}, textUI.defaultShadow),
                    "font": Object.assign({}, textUI.defaultStyle)
                }
                //console.log(json, textUI.defaultStyle)
                return new textUI(json, editor);
            }
        })
        .methods({
            changeSelect(val) {
                this.selected = val;
                if (val) this.updateFont();
                this.handler.attr({
                    class: 'sprite-help-content sprite-help-content-dashed ' + (val ? 'active' : '')
                });
            },
            updateFont(font) {
                if (font) this.json.font = font;
                textUI.defaultStyle = Object.assign({}, this.json.font);
                this.textBox.css(this.json.font);
                this.textBox.css({ 'fontFamily': '"' + this.json.font.fontFamilyUrl.split('/').pop() + '"', });
                let a = this.json.font.myTextStroke > 0 ? this.json.font.myTextStroke : 0;
                let b = this.json.font.myTextStrokeColor;
                if (a > 0) {
                    let str = [];
                    str.push(`${a}px ${a}px 2px ${b}`);
                    str.push(`${a}px ${-a}px 2px ${b}`);
                    str.push(`${-a}px ${a}px 2px ${b}`);
                    str.push(`${-a}px ${-a}px 2px ${b}`);
                    for (let i = 0; i < a; i++) {
                        str.push(`${a}px ${i}px 2px ${b}`);
                        str.push(`${-a}px ${i}px 2px ${b}`);
                        str.push(`${i}px ${a}px 2px ${b}`);
                        str.push(`${i}px ${-a}px 2px ${b}`);
                        str.push(`${i}px ${0}px 2px ${b}`);
                        str.push(`${-i}px ${0}px 2px ${b}`);
                        str.push(`${0}px ${i}px 2px ${b}`);
                        str.push(`${0}px ${-i}px 2px ${b}`);
                    }
                    this.textBox.css({
                        'text-shadow': `${str.join(',')}`
                    });
                } else {
                    this.textBox[0].style['text-shadow'] = '';
                }
            },
            updateDropShadow() {
                if (this.json.dropShadow) {
                    var scale = this.editor.scale;
                    this.textBox.css({
                        filter:
                            'drop-shadow(' + this.json.dropShadow.x * scale + 'px ' +
                            this.json.dropShadow.y * scale + 'px ' +
                            this.json.dropShadow.blur * scale + 'px ' +
                            this.json.dropShadow.color + ')'
                    });
                }
            },
            updateOutward() {
                //console.log('updateOutward', this.json.outward, this.editor.scale)
                var rect = this.json.outward;
                this.textBox.css({ width: rect.width + 'px' });
                rect.height = this.textBox[0].offsetHeight;
                this.editSize = {
                    left: rect.x * this.editor.scale,
                    top: rect.y * this.editor.scale,
                    width: rect.width * this.editor.scale,
                    height: rect.height * this.editor.scale,
                };
                this.ele.css({
                    left: this.editSize.left + "px",
                    top: this.editSize.top + "px",
                    width: this.editSize.width + "px",
                    height: this.editSize.height + "px",
                });
                this.handler.css({
                    width: this.editSize.width + "px",
                    height: this.editSize.height + "px",
                });
            },
            updateText(text) {
                if (text)
                    this.json.text = text;
                this.textBox.html(this.json.text);
                var _this = this;
                _this.json.outward.height = _this.textBox[0].offsetHeight;
                _this.updateOutward();
            },
            updateUI(sec) {
                this.updateFont();
                this.updateOutward();
                this.textBox.css({
                    transform: 'scale(' + this.editor.scale + ')',
                });
                //console.log('this.textBox', this.textBox.offsetHeight);
                this.textBox.css(this.json.font);
                this.updateDropShadow();
                if (sec >= 0) {
                    if (sec >= this.json.startTime && sec < this.json.endTime) {
                        this.textBox.css({ 'visibility': 'unset' });
                    } else {
                        this.textBox.css({ 'visibility': 'hidden' });
                    }
                }
            },
            play(sec) {
                if (sec >= 0) {
                    if (sec >= this.json.startTime && sec < this.json.endTime) {
                        this.show();
                    } else {
                        this.hide();
                    }
                }
            },
            stop(sec) {
                if (sec >= 0) {
                    if (sec >= this.json.startTime && sec < this.json.endTime) {
                        this.show();
                    } else {
                        this.hide();
                    }
                }
            },
            show() {
                this.ele.css({ 'visibility': 'unset' });
            },
            hide() {
                this.ele.css({ 'visibility': 'hidden' });
            }
        });


    var subtitleUI = klass(
        function (json, isServer) {
            this.isServer = isServer;
            this.editSize = {};
            this.editable = true;
            this.rootId = null;
            this.option = null;
            this.json = json;
            this.textUIs = [];
            this.scale = 1;
            this.ele = $('<div></div>').css({ position: 'absolute' });
            this.video = null;
            this.currentTime = 0;
            this.baseWidth = 1920;
            this.videoSize = {};

        })
        .statics({
            frameRate: 60, //fps
            frameDur: 1 / 60 //s
        })
        .methods({
            setOption(op) {
                if (op.rootId) {
                    if (this.rootId) this.ele.remove();
                    this.rootEle = $('#' + op.rootId);
                    this.rootEle.append(this.ele);
                    this.rootId = op.rootId;
                    //console.log('this.rootId', this.rootId, this.rootEle, this.ele);
                }
                //style
                this.editSize = {
                    top: (op.top || 0),
                    left: (op.left || 0),
                    width: (op.width || 0),
                    height: (op.height || 0)
                }
                this.ele.css({
                    top: this.editSize.top + 'px',
                    left: this.editSize.left + 'px',
                    width: this.editSize.width + 'px',
                    height: this.editSize.height + 'px',
                    position: 'relative',
                });
                if (this.json && this.json.type == 'draft') {
                    this.scale = op.width / 1920;
                } else {
                    this.scale = op.width / 1920;
                }
                for (let i = 0; i < this.textUIs.length; i++) {
                    this.textUIs[i].updateUI();
                }

                if (this.video && this.json && this.json.resolution) {
                    var baseW = (this.json.resolution.width / this.json.resolution.height) > (16 / 9);
                    var videoscale = 1;
                    if (baseW) {
                        videoscale = this.editSize.width / this.json.resolution.width;
                        this.baseWidth = 1920;
                    } else {
                        videoscale = this.editSize.height / this.json.resolution.height;
                        this.baseWidth = this.json.resolution.width / (this.json.resolution.height / 1080);
                    }
                    var width = this.json.resolution.width * videoscale;
                    var height = this.json.resolution.height * videoscale;
                    this.videoSize = { width, height };
                    this.video.attr({ width, height });
                }

                if (this.json && this.json.type === 'draft' && this.json.optimized !== 'Horizontal') {
                    this.baseWidth = 607.5;
                }
            },
            loadUI(json) {
                if (json) this.json = json;
                // console.log('loadUI(json)', this.json);
                // if(this.json === undefined){
                // }
                this.ele.empty();
                this.textUIs = [];
                if (this.json && this.json.type === 'video' && !this.isServer) {
                    this.video = $('<video></video>').attr({
                        src: "https://resources.laihua.com/" + this.json.url,
                    })
                    this.ele.append(this.video);
                }
                //console.log('loadUI(json)',this.json,this.ele[0],this.video[0]); this.json && this.json.contents &&
                if (this.json && this.json.contents && this.json.contents.length > 0) {
                    for (let i = 0; i < this.json.contents.length; i++) {
                        let item = new textUI(this.json.contents[i], this);
                        this.textUIs.push(item);
                        this.ele.append(item.ele);
                    }
                }
            },
            selectIndex(index) {
                for (let i = 0; i < this.textUIs.length; i++) {
                    if (i === index)
                        this.textUIs[i].changeSelect(true);
                    else this.textUIs[i].changeSelect(false);
                }
            },
            insertText(index, json) {
                var idx = index < 0 ? 0 : index;
                idx = index > this.json.contents.length ? this.json.contents.length : index;
                if (json) {
                    if (!json.outward) {
                        json.outward = {
                            "opacity": 1.0,
                            "rotation": 0.0,
                            "width": this.baseWidth * 0.8,
                            "height": json.font.fontSize,
                            "x": 1920 / 2 - this.baseWidth * 0.4,
                            "y": 1080 - json.font.fontSize * 2,
                            "isFlipped": false
                        }
                    }
                    var ui = new textUI(json, this);
                    this.textUIs.splice(idx, 0, ui);
                    this.json.contents.splice(idx, 0, json);
                    this.ele.append(ui.ele);
                    return json;
                }
            },
            removeText(index) {
                var t = this.textUIs[index];
                if (t) {
                    t.ele.remove();
                    this.textUIs.splice(index, 1);
                    this.json.contents.splice(index, 1);
                }
            },
            clear() {
                for (let i = 0; i < this.textUIs.length; i++) {
                    this.textUIs[i].ele.remove();
                }
                this.textUIs = [];
                this.json && (this.json.contents = []);
            },
            play(frame) {  //进入预览
                this.currentTime = frame / subtitleUI.frameRate;
                if (this.editable) {
                    for (let i = 0; i < this.textUIs.length; i++) {
                        this.textUIs[i].changeSelect(false);
                    }
                    if (this.video) {
                        this.video[0].currentTime = this.currentTime;
                        this.video[0].play();
                    }
                }
                this.editable = false;
                this.playing(frame);
            },
            playing(frame) { //播放帧
                this.currentTime = frame / subtitleUI.frameRate;
                for (let i = 0; i < this.textUIs.length; i++) {
                    this.textUIs[i].play(this.currentTime);
                }
            },
            stop(frame) {  //退出预览
                this.editable = true;
                this.currentTime = frame / subtitleUI.frameRate;
                if (this.video) {
                    this.video[0].pause();
                    this.video[0].currentTime = this.currentTime;
                }
                var sec = frame * 1 / subtitleUI.frameRate;
                for (let i = 0; i < this.textUIs.length; i++) {
                    this.textUIs[i].stop(sec);
                }
            }
        });

    this.subtitleUI = subtitleUI;
    return subtitleUI;
})





//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/subtitle/subtitleUI.js
// module id = 2cb4
// module chunks = 16